// Main imports
import Vue from 'vue'
import VueRouter from 'vue-router'

// // Vuetify locales
import routes from '@/routes'

// Create component
Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

const CHUNK_RELOAD_KEY = 'chunkReloadAt'
const CHUNK_RELOAD_COOLDOWN = 10000

let pendingRoute = null

router.beforeEach((to, from, next) => {
  pendingRoute = to
  next()
})

function isChunkLoadError (err) {
  return err.name === 'ChunkLoadError' || /Loading (CSS )?chunk .+ failed/.test(err.message)
}

function canReload () {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0
    if (Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN) return false
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
    return true
  } catch (e) {
    return false
  }
}

router.onError((err) => {
  if (!isChunkLoadError(err) || !canReload()) {
    console.error(err)
    return
  }

  if (pendingRoute) {
    window.history.replaceState(window.history.state, '', `#${pendingRoute.fullPath}`)
  }
  window.location.reload()
})

export default router
